<app-loading *ngIf="documentFindOneByIdService.loading$ | async"></app-loading>
<app-error-card [error]="error" *ngIf="error"></app-error-card>
<ng-container *ngIf="document && !error">
    <div class="button-bar" *ngIf="authService.user | async">
        <app-button fill="solid" iconName="send" label="Envoyer le lien" (clickEvent)="send()"></app-button>
    </div>

    <div class="row">
        <div class="col-12">
            <app-card-v2 [title]="document.signature ? 'Document signé' : 'Document à signer'">
                <app-loading [loading]="documentDownloadService.loading$ | async"></app-loading>
                <app-pdf-preview [blob]="pdf"></app-pdf-preview>
                <div class="text-center" *ngIf="displayDownloadButton">
                    <app-button
                            label="Télécharger"
                            fill="solid"
                            (clickEvent)="download()">
                    </app-button>
                </div>
            </app-card-v2>
        </div>
        <div class="col-12" *ngIf="!document.signature">
            <app-card-v2 title="Signer">
                <div class="row">
                    <app-form-field label="Date de la signature">
                        <app-date-picker [parentFormGroup]="formGroup" parentFormControlName="date"></app-date-picker>
                    </app-form-field>
                    <app-form-field label="Votre nom" [required]="true">
                        <app-input-text [parentFormGroup]="formGroup" parentFormControlName="name"></app-input-text>
                    </app-form-field>
                    <app-form-field label="Votre adresse e-mail">
                        <app-email-input [parentFormGroup]="formGroup" parentFormControlName="email"></app-email-input>
                    </app-form-field>

                    <app-document-template-generate-form    *ngIf="template"
                                                            [parentFormGroup]="formGroup"
                                                            [partnerId]="document?.summary?.partner?.id"
                                                            [documentTemplate]="template"
                                                            inputStepValue="DOCUMENT_TEMPLATE_PLACE_HOLDER_INPUT_STEP_AT_EXTERNAL_SIGNATURE"></app-document-template-generate-form>

                </div>
                <app-loading *ngIf="documentTemplateFindOneByIdService.loading$ | async"></app-loading>
                <div class="row">
                    <app-form-field size="12" label="Signature">
                        <div style="width: 100%; max-width: 500px;">
                            <app-signature-input (signatureChange)="signatureChanged($event)"></app-signature-input>
                        </div>
                    </app-form-field>
                </div>
            </app-card-v2>
        </div>
        <div class="col-12 text-center" *ngIf="!document.signature && displaySignButton">
                <app-button fill="solid" [disabled]="!formGroup.valid || (documentTemplateFindOneByIdService.loading$ | async)"
                            (clickEvent)="sign()"
                            [loading]="(documentSignService.loading$ | async) || (documentTemplateSignService.loading$ | async)"
                            label="Signer" iconName="signature"></app-button>
        </div>
    </div>


    <ng-container *ngIf="!document.signature">
    </ng-container>
    <app-card *ngIf="document.signature as signature" title="Signature effectuée">
        <div class="row">
            <app-form-field label="Date de la signature">
                <app-date-summary-field [date]="signature.date"></app-date-summary-field>
            </app-form-field>
            <app-form-field label="Nom" [required]="true">
                <app-summary-field [value]="signature.name"></app-summary-field>
            </app-form-field>
            <app-form-field label="Adresse e-mail">
                <app-summary-field [value]="signature.email"></app-summary-field>
            </app-form-field>
            <app-form-field size="12" label="Signature" class="text-center">
                <img [src]="signature.signature" style="height: 150px;" alt="Signature"/>
            </app-form-field>
        </div>
    </app-card>
</ng-container>
